var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWatching(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 33.478,
    height: 33.474,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_watching",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(337.094 223.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225-2",
    "data-name": "Group 225",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21952",
    "data-name": "Path 21952",
    d: "M16.183,32.122A15.938,15.938,0,1,1,32.122,16.183,15.936,15.936,0,0,1,16.183,32.122",
    transform: "translate(0.554 0.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21953",
    "data-name": "Path 21953",
    d: "M28.5,12.732a15.691,15.691,0,0,0-2.449-8.419A15.759,15.759,0,0,0,4.294,26.071,15.77,15.77,0,0,0,28.5,12.732",
    transform: "translate(4.119 4.154)",
    fill: "#f1c14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21954",
    "data-name": "Path 21954",
    d: "M16.737,33.474A16.737,16.737,0,1,1,33.474,16.737,16.755,16.755,0,0,1,16.737,33.474m0-31.877A15.139,15.139,0,1,0,31.877,16.737,15.157,15.157,0,0,0,16.737,1.6",
    transform: "translate(0 -0.001)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21955",
    "data-name": "Path 21955",
    d: "M3.282,2.253l16.264,9.391L3.282,21.032Z",
    transform: "translate(7.421 5.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21956",
    "data-name": "Path 21956",
    d: "M3.037,23.379V1.829L21.7,12.6ZM4.635,4.6V20.611L18.5,12.6Z",
    transform: "translate(6.866 4.134)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWatching);
export default __webpack_public_path__ + "static/media/ic_watching.26819555b979c26c3a6aa9bedf28f263.svg";
export { ForwardRef as ReactComponent };